import classNames from 'classnames';
import { ReactNode } from 'react';
import { useSyncScrollRef } from '../scroller/useSyncScrollRef';
import { useStyles } from '../virtualizedTable.styles';

interface StickyGroupSlotProps {
  top: number;
  height: number;
  zIndex: number;
  isDeepest: boolean;
  children: ReactNode;
}

const StickyGroupSlot = ({ top, height, zIndex, isDeepest, children }: StickyGroupSlotProps) => {
  const { classes } = useStyles();
  const syncScrollRef = useSyncScrollRef();

  return (
    <div
      className={classNames(classes.stickyGroupSlot, {
        [classes.stickyGroupDeepestSlot]: isDeepest,
      })}
      style={{ top, height, zIndex }}
    >
      <div
        ref={syncScrollRef}
        className={classNames(classes.fixedHeader, classes.stickyGroupSlotContent)}
      >
        {children}
      </div>
    </div>
  );
};

export default StickyGroupSlot;
